import React from 'react';
import TimesheetHeader from './TimesheetHeader';
import TimesheetInfoSection from './TimesheetInfoSection';
import TimesheetEntries from './TimesheetEntries';
import TimesheetFooter from './TimesheetFooter';

export default function TimesheetDocument({ timesheet, entries, printRef }) {
  return (
    <div 
      ref={printRef} 
      id="timesheet-document" 
      className="bg-white w-full max-w-3xl shadow-xl rounded-lg overflow-hidden print:shadow-none print:rounded-none print:max-w-none" 
      style={{ fontFamily: "'Inter', system-ui, sans-serif" }}
    >
      <TimesheetHeader timesheet={timesheet} />
      
      <div className="px-6 py-4">
        <TimesheetInfoSection timesheet={timesheet} />
        <TimesheetEntries entries={entries} />
      </div>
      
      <TimesheetFooter timesheet={timesheet} />
    </div>
  );
}
